import moment from 'moment'
import { format } from './dateFormat'

export const formatDateTime = (date: moment.MomentInput, formatTo = format.shortDateFull, formatFrom?: string) => {
  if (!date) return ''

  const m = moment(date, formatFrom)

  if (!m.isValid()) return ''

  if (m.isSame('0001-01-01', 'day')) return ''

  return m.format(formatTo)
}
